// extracted by mini-css-extract-plugin
module.exports = {"title":"leaveReview-module--title--2N4Bq","form":"leaveReview-module--form--3Knpx","btn":"leaveReview-module--btn--2DhH_","starRating":"leaveReview-module--starRating--2B7i1"};